
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404EfC5nBBvCJMeta } from "/opt/ybd/ui/ym/src/pages/404.vue?macro=true";
import { default as aboutDJecBTiuvFMeta } from "/opt/ybd/ui/ym/src/pages/about.vue?macro=true";
import { default as activity8zdXSmh0T1Meta } from "/opt/ybd/ui/ym/src/pages/activity.vue?macro=true";
import { default as indexKzVt4kgklYMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/billing/index.vue?macro=true";
import { default as indexOzhdghJx5AMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/index.vue?macro=true";
import { default as indexcNtsrMLbwrMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/instances/index.vue?macro=true";
import { default as indexKMlXAYUD7cMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/license/index.vue?macro=true";
import { default as indexaoGsffZg8qMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/manage-access/index.vue?macro=true";
import { default as indexfNf8csZPx8Meta } from "/opt/ybd/ui/ym/src/pages/configuration/index/manager/index.vue?macro=true";
import { default as indexsTjoF5Jr4nMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/metering/index.vue?macro=true";
import { default as indexEOSnLbydOdMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/observability/index.vue?macro=true";
import { default as indexcRPm40vSPeMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/sites/index.vue?macro=true";
import { default as indexiipZCIQK5OMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index/sso/index.vue?macro=true";
import { default as index0WHnYH0hmVMeta } from "/opt/ybd/ui/ym/src/pages/configuration/index.vue?macro=true";
import { default as format_45datavPvxqVA4NnMeta } from "/opt/ybd/ui/ym/src/pages/data-wizard/index/format-data.vue?macro=true";
import { default as indexJ9UX49UNPVMeta } from "/opt/ybd/ui/ym/src/pages/data-wizard/index/index.vue?macro=true";
import { default as load_45datairklyOeqzoMeta } from "/opt/ybd/ui/ym/src/pages/data-wizard/index/load-data.vue?macro=true";
import { default as select_45data6shZhBzGU6Meta } from "/opt/ybd/ui/ym/src/pages/data-wizard/index/select-data.vue?macro=true";
import { default as indexETkBNxqRTQMeta } from "/opt/ybd/ui/ym/src/pages/data-wizard/index.vue?macro=true";
import { default as drivers_45toolsyOZRhGEWNoMeta } from "/opt/ybd/ui/ym/src/pages/drivers-tools.vue?macro=true";
import { default as feature_45flagsmlC0HCf3GqMeta } from "/opt/ybd/ui/ym/src/pages/feature-flags.vue?macro=true";
import { default as homezL9La0OqNzMeta } from "/opt/ybd/ui/ym/src/pages/home.vue?macro=true";
import { default as indexthrd5X7J7JMeta } from "/opt/ybd/ui/ym/src/pages/index.vue?macro=true";
import { default as indexiMyhU0QeWLMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/index.vue?macro=true";
import { default as indexBl8tLDfdz3Meta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/access-control/index.vue?macro=true";
import { default as backupXcVPlJJwldMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/backup.vue?macro=true";
import { default as loadCvF5nAK3KlMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/load.vue?macro=true";
import { default as queryqiBeV2BOOPMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/query.vue?macro=true";
import { default as restoreJdhye2xYi9Meta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/restore.vue?macro=true";
import { default as sessioniUMy6hx2XUMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/session.vue?macro=true";
import { default as unloadWQYwQ3qAvxMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/unload.vue?macro=true";
import { default as activityAhf7El38XRMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity.vue?macro=true";
import { default as _91cluster_id_93YRcTnKxqLqMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/clusters/[cluster_id].vue?macro=true";
import { default as indexpeO6DOcytUMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/clusters/index.vue?macro=true";
import { default as clustersXZakiWXdVpMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/clusters.vue?macro=true";
import { default as configuration9OacNAKshAMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/configuration.vue?macro=true";
import { default as index1xW3Pco3RfMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases/database/[database_id]/index.vue?macro=true";
import { default as _91schema_id_93dczrfN89cwMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases/database/[database_id]/schemas/[schema_id].vue?macro=true";
import { default as _91database_id_939EFQf4DZwaMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases/database/[database_id].vue?macro=true";
import { default as indexTsIqVK26R5Meta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases/index.vue?macro=true";
import { default as databasesTHAfnPWX3CMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases.vue?macro=true";
import { default as execution_45timelineqGbaoSfUyAMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/execution-timeline.vue?macro=true";
import { default as external_45resourcesTkL18AgMtNMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/external-resources.vue?macro=true";
import { default as indexC0Xtn2qUfXMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/index.vue?macro=true";
import { default as indexuYWZcbNBNqMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/instance-health/index.vue?macro=true";
import { default as ldapf3rgXx7Ak9Meta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/ldap.vue?macro=true";
import { default as licensezTasXjrVByMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/license.vue?macro=true";
import { default as reservationsbZ5E7046LWMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/reservations.vue?macro=true";
import { default as restrict_45accesslHMborQ2CHMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/restrict-access.vue?macro=true";
import { default as settings0XAhpVhWjzMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/settings.vue?macro=true";
import { default as shared_45servicesjyEBAuooFEMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/shared-services.vue?macro=true";
import { default as usage_45meteringT33PpPCVKfMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/usage-metering.vue?macro=true";
import { default as global_45rulesxg0ZeZh4JXMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management/global-rules.vue?macro=true";
import { default as indexjQYLa4LchzMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management/index.vue?macro=true";
import { default as _91wlm_profile_id_93oYEuPys7iGMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management/profiles/[wlm_profile_id].vue?macro=true";
import { default as rule_45processingfw9444Z8TFMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management/rule-processing.vue?macro=true";
import { default as workload_45managementyLxK4delRdMeta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management.vue?macro=true";
import { default as _91instance_id_93XTJCRtEI13Meta } from "/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id].vue?macro=true";
import { default as index3qcy7tjSXCMeta } from "/opt/ybd/ui/ym/src/pages/instances/index.vue?macro=true";
import { default as loginZ00GjElbUcMeta } from "/opt/ybd/ui/ym/src/pages/login.vue?macro=true";
import { default as not_45authorizedJnPjVPx0SzMeta } from "/opt/ybd/ui/ym/src/pages/not-authorized.vue?macro=true";
import { default as queryBqrgw3uLGEMeta } from "/opt/ybd/ui/ym/src/pages/query.vue?macro=true";
import { default as disclosurez42lQ1lK6VMeta } from "/opt/ybd/ui/ym/src/pages/test/disclosure.vue?macro=true";
import { default as tabsYQ1RPsNHbBMeta } from "/opt/ybd/ui/ym/src/pages/test/tabs.vue?macro=true";
import { default as TestTimelineu0Rzhtqv3cMeta } from "/opt/ybd/ui/ym/src/pages/TestTimeline.vue?macro=true";
import { default as thanksto2W9HOdN0Meta } from "/opt/ybd/ui/ym/src/pages/thanks.vue?macro=true";
import { default as token_45authenticated1yPzHdTYDrMeta } from "/opt/ybd/ui/ym/src/pages/token-authenticated.vue?macro=true";
import { default as welcome2Vx3Opr2T9Meta } from "/opt/ybd/ui/ym/src/pages/welcome.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _404EfC5nBBvCJMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/404.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: aboutDJecBTiuvFMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/about.vue")
  },
  {
    name: "activity",
    path: "/activity",
    component: () => import("/opt/ybd/ui/ym/src/pages/activity.vue")
  },
  {
    name: index0WHnYH0hmVMeta?.name,
    path: "/configuration",
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index.vue"),
    children: [
  {
    name: "yb-configuration-billing-usage",
    path: "billing",
    meta: indexKzVt4kgklYMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/billing/index.vue")
  },
  {
    name: "yb-configuration",
    path: "",
    meta: indexOzhdghJx5AMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/index.vue")
  },
  {
    name: "yb-configuration-instances",
    path: "instances",
    meta: indexcNtsrMLbwrMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/instances/index.vue")
  },
  {
    name: "yb-configuration-license",
    path: "license",
    meta: indexKMlXAYUD7cMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/license/index.vue")
  },
  {
    name: "yb-configuration-manage-access",
    path: "manage-access",
    meta: indexaoGsffZg8qMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/manage-access/index.vue")
  },
  {
    name: "yb-configuration-manager",
    path: "manager",
    meta: indexfNf8csZPx8Meta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/manager/index.vue")
  },
  {
    name: "yb-configuration-metering",
    path: "metering",
    meta: indexsTjoF5Jr4nMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/metering/index.vue")
  },
  {
    name: "yb-configuration-observability",
    path: "observability",
    meta: indexEOSnLbydOdMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/observability/index.vue")
  },
  {
    name: "yb-configuration-sites",
    path: "sites",
    meta: indexcRPm40vSPeMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/sites/index.vue")
  },
  {
    name: "yb-configuration-single-sign-on",
    path: "sso",
    meta: indexiipZCIQK5OMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/configuration/index/sso/index.vue")
  }
]
  },
  {
    name: "yb-data-wizard",
    path: "/data-wizard",
    meta: indexETkBNxqRTQMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/data-wizard/index.vue"),
    children: [
  {
    name: "data-wizard-index-format-data",
    path: "format-data",
    component: () => import("/opt/ybd/ui/ym/src/pages/data-wizard/index/format-data.vue")
  },
  {
    name: "data-wizard-index",
    path: "",
    meta: indexJ9UX49UNPVMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/data-wizard/index/index.vue")
  },
  {
    name: "data-wizard-index-load-data",
    path: "load-data",
    meta: load_45datairklyOeqzoMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/data-wizard/index/load-data.vue")
  },
  {
    name: "data-wizard-index-select-data",
    path: "select-data",
    meta: select_45data6shZhBzGU6Meta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/data-wizard/index/select-data.vue")
  }
]
  },
  {
    name: "drivers-tools",
    path: "/drivers-tools",
    component: () => import("/opt/ybd/ui/ym/src/pages/drivers-tools.vue")
  },
  {
    name: "feature-flags",
    path: "/feature-flags",
    meta: feature_45flagsmlC0HCf3GqMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/feature-flags.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homezL9La0OqNzMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/ybd/ui/ym/src/pages/index.vue")
  },
  {
    name: index3qcy7tjSXCMeta?.name,
    path: "/instances",
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index.vue"),
    children: [
  {
    name: "yb-instances",
    path: "",
    meta: indexiMyhU0QeWLMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/index.vue")
  },
  {
    name: _91instance_id_93XTJCRtEI13Meta?.name,
    path: "instance/:instance_id()",
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id].vue"),
    children: [
  {
    name: "yb-instance-access-control",
    path: "access-control",
    meta: indexBl8tLDfdz3Meta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/access-control/index.vue")
  },
  {
    name: "instances-index-instance-instance_id-activity",
    path: "activity",
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity.vue"),
    children: [
  {
    name: "yb-instance-activity-backup",
    path: "backup",
    meta: backupXcVPlJJwldMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/backup.vue")
  },
  {
    name: "yb-instance-activity-load",
    path: "load",
    meta: loadCvF5nAK3KlMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/load.vue")
  },
  {
    name: "yb-instance-activity-query",
    path: "query",
    meta: queryqiBeV2BOOPMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/query.vue")
  },
  {
    name: "yb-instance-activity-restore",
    path: "restore",
    meta: restoreJdhye2xYi9Meta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/restore.vue")
  },
  {
    name: "yb-instance-activity-session",
    path: "session",
    meta: sessioniUMy6hx2XUMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/session.vue")
  },
  {
    name: "yb-instance-activity-unload",
    path: "unload",
    meta: unloadWQYwQ3qAvxMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/activity/unload.vue")
  }
]
  },
  {
    name: clustersXZakiWXdVpMeta?.name,
    path: "clusters",
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/clusters.vue"),
    children: [
  {
    name: "yb-cluster",
    path: ":cluster_id()",
    meta: _91cluster_id_93YRcTnKxqLqMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/clusters/[cluster_id].vue")
  },
  {
    name: "yb-clusters",
    path: "",
    meta: indexpeO6DOcytUMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/clusters/index.vue")
  }
]
  },
  {
    name: "yb-instance-configuration",
    path: "configuration",
    meta: configuration9OacNAKshAMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/configuration.vue")
  },
  {
    name: databasesTHAfnPWX3CMeta?.name,
    path: "databases",
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases.vue"),
    children: [
  {
    name: _91database_id_939EFQf4DZwaMeta?.name,
    path: "database/:database_id()",
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases/database/[database_id].vue"),
    children: [
  {
    name: "yb-database",
    path: "",
    meta: index1xW3Pco3RfMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases/database/[database_id]/index.vue")
  },
  {
    name: "yb-schema",
    path: "schemas/:schema_id()",
    meta: _91schema_id_93dczrfN89cwMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases/database/[database_id]/schemas/[schema_id].vue")
  }
]
  },
  {
    name: "yb-databases",
    path: "",
    meta: indexTsIqVK26R5Meta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/databases/index.vue")
  }
]
  },
  {
    name: "yb-instance-execution-timeline",
    path: "execution-timeline",
    meta: execution_45timelineqGbaoSfUyAMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/execution-timeline.vue")
  },
  {
    name: "yb-instance-external-resources",
    path: "external-resources",
    meta: external_45resourcesTkL18AgMtNMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/external-resources.vue")
  },
  {
    name: "yb-instance",
    path: "",
    meta: indexC0Xtn2qUfXMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/index.vue")
  },
  {
    name: "yb-instance-management-health",
    path: "instance-health",
    meta: indexuYWZcbNBNqMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/instance-health/index.vue")
  },
  {
    name: "yb-instance-management-ldap",
    path: "ldap",
    meta: ldapf3rgXx7Ak9Meta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/ldap.vue")
  },
  {
    name: "yb-instance-management-license",
    path: "license",
    meta: licensezTasXjrVByMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/license.vue")
  },
  {
    name: "yb-instance-management-reservations",
    path: "reservations",
    meta: reservationsbZ5E7046LWMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/reservations.vue")
  },
  {
    name: "yb-instance-management-restrict-access",
    path: "restrict-access",
    meta: restrict_45accesslHMborQ2CHMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/restrict-access.vue")
  },
  {
    name: "yb-instance-management-settings",
    path: "settings",
    meta: settings0XAhpVhWjzMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/settings.vue")
  },
  {
    name: "yb-instance-management-shared-services",
    path: "shared-services",
    meta: shared_45servicesjyEBAuooFEMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/shared-services.vue")
  },
  {
    name: "yb-instance-management-usage-metering",
    path: "usage-metering",
    meta: usage_45meteringT33PpPCVKfMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/usage-metering.vue")
  },
  {
    name: workload_45managementyLxK4delRdMeta?.name,
    path: "workload-management",
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management.vue"),
    children: [
  {
    name: "yb-instance-wlm-global-rules",
    path: "global-rules",
    meta: global_45rulesxg0ZeZh4JXMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management/global-rules.vue")
  },
  {
    name: "yb-wlm",
    path: "",
    meta: indexjQYLa4LchzMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management/index.vue")
  },
  {
    name: "yb-wlm-profile",
    path: "profiles/:wlm_profile_id()",
    meta: _91wlm_profile_id_93oYEuPys7iGMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management/profiles/[wlm_profile_id].vue")
  },
  {
    name: "yb-instance-wlm-rule-processing",
    path: "rule-processing",
    meta: rule_45processingfw9444Z8TFMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/instances/index/instance/[instance_id]/workload-management/rule-processing.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "login",
    path: "/login",
    meta: loginZ00GjElbUcMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/login.vue")
  },
  {
    name: "not-authorized",
    path: "/not-authorized",
    meta: not_45authorizedJnPjVPx0SzMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/not-authorized.vue")
  },
  {
    name: "yb-query",
    path: "/query",
    meta: queryBqrgw3uLGEMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/query.vue")
  },
  {
    name: "test-disclosure",
    path: "/test/disclosure",
    meta: disclosurez42lQ1lK6VMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/test/disclosure.vue")
  },
  {
    name: "test-tabs",
    path: "/test/tabs",
    meta: tabsYQ1RPsNHbBMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/test/tabs.vue")
  },
  {
    name: "TestTimeline",
    path: "/TestTimeline",
    meta: TestTimelineu0Rzhtqv3cMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/TestTimeline.vue")
  },
  {
    name: "thanks",
    path: "/thanks",
    meta: thanksto2W9HOdN0Meta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/thanks.vue")
  },
  {
    name: "token-authenticated",
    path: "/token-authenticated",
    meta: token_45authenticated1yPzHdTYDrMeta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/token-authenticated.vue")
  },
  {
    name: "yb-welcome",
    path: "/welcome",
    meta: welcome2Vx3Opr2T9Meta || {},
    component: () => import("/opt/ybd/ui/ym/src/pages/welcome.vue")
  }
]